import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithTokenRefresh } from '../../common/baseQuery'
import { BaseRequest, BaseResponse } from '../models'

// Define a service using a base URL and expected endpoints
const _BASE_URL = import.meta.env.REACT_APP_AUTH_API_BASE_URL!

export interface SignupChangeResponse {
  signupChangeLink: string
}

export const signupChangeApi = createApi({
  reducerPath: 'signupChangeApi',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  endpoints: (builder) => ({
    signupChangeMe: builder.mutation<BaseResponse<SignupChangeResponse>, BaseRequest>({
      query: ({ accountId }) => ({
        url: `/v2/accounts/${accountId}/signup-change/me`,
        method: 'POST',
      }),
    }),
  }),
})

export const { useSignupChangeMeMutation } = signupChangeApi
